/* Platform identity: the transparent FM hex mark (works on light and dark) + "Facilities Management Platform"
   wordmark rendered as text, so it stays crisp at every size and follows light/dark mode. */
const MARK = "/fm-logo.png";
const NAME = "Facilities Management Platform";

export default function PlatformBrand({ variant = "sidebar", className = "" }) {
  if (variant === "icon") {
    return <img src={MARK} alt={NAME} className={`h-9 w-9 object-contain ${className}`} data-testid="sidebar-logo-icon" />;
  }
  if (variant === "mobile") {
    return (
      <span className={`flex items-center gap-1.5 min-w-0 ${className}`} data-testid="mobile-brand">
        <img src={MARK} alt={NAME} className="h-7 w-7 object-contain shrink-0" />
        <span className="font-bold text-[13px] font-[Chivo] truncate">FM Platform</span>
      </span>
    );
  }
  if (variant === "login-hero") {
    return (
      <div className={`flex items-center gap-4 ${className}`} data-testid="login-brand-hero">
        <img src={MARK} alt={NAME} className="h-[4.5rem] w-[4.5rem] lg:h-20 lg:w-20 object-contain shrink-0 drop-shadow-[0_6px_16px_rgba(0,0,0,0.35)]" />
        <div className="leading-[1.3] text-sm lg:text-base xl:text-lg font-semibold uppercase tracking-[0.14em] text-slate-300 whitespace-nowrap">
          <p data-testid="login-brand-hero-line-1">Facilities Management</p>
          <p data-testid="login-brand-hero-line-2">Platform</p>
        </div>
      </div>
    );
  }
  if (variant === "login-right") {
    return (
      <span className={`flex items-center gap-2.5 min-w-0 ${className}`} data-testid="login-brand-right">
        <img src={MARK} alt={NAME} className="h-10 w-10 lg:h-11 lg:w-11 object-contain shrink-0" />
        <span className="leading-[1.3] min-w-0 text-[10.5px] lg:text-[11.5px] 2xl:text-[13px] font-semibold uppercase tracking-[0.12em] text-muted-foreground whitespace-nowrap">
          <span className="block" data-testid="login-brand-right-line-1">Facilities Management</span>
          <span className="block" data-testid="login-brand-right-line-2">Platform</span>
        </span>
      </span>
    );
  }
  if (variant === "powered") {
    return (
      <span className={`inline-flex items-center gap-1.5 ${className}`} data-testid="powered-by-brand">
        <img src={MARK} alt={NAME} className="h-4 w-4 object-contain" />
        <span className="font-semibold">{NAME}</span>
      </span>
    );
  }
  // sidebar (expanded) — one uniform wordmark over two lines; scales up with the sidebar on larger screens
  return (
    <span className={`flex items-center gap-2.5 min-w-0 ${className}`} data-testid="sidebar-logo">
      <img src={MARK} alt={NAME} className="h-9 w-9 xl:h-10 xl:w-10 object-contain shrink-0" />
      <span className="leading-[1.3] min-w-0 text-[10.5px] xl:text-[11.5px] 2xl:text-[13px] font-semibold uppercase tracking-[0.12em] text-muted-foreground whitespace-nowrap">
        <span className="block" data-testid="sidebar-logo-line-1">Facilities Management</span>
        <span className="block" data-testid="sidebar-logo-line-2">Platform</span>
      </span>
    </span>
  );
}
